import React, { Component, useState } from 'react';
import { Input } from 'antd';

export default function FloatLabelNumberComponent(props) {
  const [isFloat, setFloat] = useState(false);

  return (
    <div style={{ position: 'relative' }}>
      <label
        htmlFor={props.name || ''}
        style={{
			  position: 'absolute',
			  top: isFloat ? '-40%' : '50%',
			  fontWeight: isFloat ? 'normal' : 'bold',
			  opacity: isFloat ? '1' : '0.7',
			  transform: isFloat ? 'scale(0.9) translate(5px, -50%)' : 'scale(1) translate(5px, -50%)',
			  backgroundColor: 'rgba(255,255,255,0.8)',
			  transition: 'all ease-in-out .2s',
			  zIndex: 1,
        }}
        onClick={() => setFloat(true)}
      >
        {props.label || ''}
      </label>
      <Input.Password
        id={props.name || ''}
        {...props}
        onFocus={() => {
				                setFloat(true);
			                }}
        onBlur={() => {
				                setFloat(!window._.isEmpty(props.value));
			                }}
      />
    </div>
  );
}
